const _UTILS = {
  async AddItemsToCart(items_to_add, sections) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items: items_to_add,
        sections: sections ? sections : ['cart']
      })
    })
  }
}
